import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material';
import { EncomendaHistorico, PackageStatus } from 'src/app/api';
import { filter, map, switchMap, tap } from 'rxjs/operators';
import { BlockPackageDialogComponent } from '../../dialogs/block-package-dialog/block-package-dialog.component';
import { CannotBlockPackageDialogComponent } from '../../dialogs/cannot-block-package-dialog/cannot-block-package-dialog.component';
import { ServiceSuspendedDialogComponent } from '../../dialogs/service-suspended-dialog/service-suspended-dialog.component';
import { UiRouterState } from '../../services/ajs-router-state.service';
import { ProfileBetaFeatureService } from '../../services/profile/profile-beta-feature.service';
import { ProfileService } from '../../services/profile/profile.service';
import { OrderService } from 'src/app/services/order.service';

@Component({
  selector: 'mandae-package-list-element-actions',
  templateUrl: './package-list-element-actions.component.html',
  styleUrls: ['./package-list-element-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PackageListElementActionsComponent implements OnInit {

  @Input()
  public element: EncomendaHistorico;

  @Output()
  public refresh = new EventEmitter();

  private canMakeReversePackages = false;
  private canBlockPackages = false;

  constructor(
    private profileBetaFeatureService: ProfileBetaFeatureService,
    private profileService: ProfileService,
    private changeDetectorRef: ChangeDetectorRef,
    private state: UiRouterState,
    private dialog: MatDialog,
    private orderService: OrderService,
  ) { }

  ngOnInit() {
    this.profileBetaFeatureService.hasFeature('reversa').subscribe(access => {
      this.canMakeReversePackages = access;
      this.changeDetectorRef.markForCheck();
    });
    this.profileBetaFeatureService.hasFeature('bloqueio').subscribe(access => {
      this.canBlockPackages = access;
      this.changeDetectorRef.markForCheck();
    });
  }

  shouldShowBlock() {
    if (!this.canBlockPackages) {
      return false;
    }

    return ![ PackageStatus.Bloqueada, PackageStatus.Cancelada, PackageStatus.Entregue ].includes(this.element.codigoSituacao);
  }

  shouldShowMakeReverse() {
    if (!this.canMakeReversePackages) {
      return false;
    }

    return [ PackageStatus.Enviada, PackageStatus.Entregue, PackageStatus.AguardandoRetiradaDestinatario ]
      .includes(this.element.codigoSituacao);
  }

  makeReverse() {
    this.profileService.isActive().subscribe(isActive => {
      if (isActive) {
        return this.state.go('reverse-form', {
          originalOrderId: this.element.idOrdemServico,
          originalPackageId: this.element.id,
        });
      }

      this.dialog.open(ServiceSuspendedDialogComponent, {
        data: {
          redirectToPackagesList: false,
          operationName: 'a solicitação de logística reversa',
        }
      });
    });
  }

  async block() {
    const response = JSON.parse(await this.orderService.podeBloquearEncomenda(this.element.id));

    const dialog = this.dialog.open(response.pode ? BlockPackageDialogComponent : CannotBlockPackageDialogComponent, {
      data: this.element,
    });

    dialog.afterClosed().pipe(filter(result => !!result),
    tap(() => this.refresh.emit())).subscribe();
  }

}
